import { useSuspenseQuery } from "@tanstack/react-query";
import { useAxios } from "auth-sdk";
import type { FundingApplicationSchemas } from "api-types";

import { AuthCallbackPath } from "../../api-types/connector-callbacks";
import { FUNDING_APPLICATION_CONNECTORS_API } from "../../components/constants";

export const usePlatformConnectorProperties = (
  customerDomain: string,
  connectorSlug: string,
  postConnectPath: AuthCallbackPath
) => {
  const client = useAxios();

  const fetchUrl = FUNDING_APPLICATION_CONNECTORS_API.replace(":customerSlug", customerDomain) + connectorSlug;

  const params = new URLSearchParams({ callbackPath: postConnectPath });
  // create the query function
  const queryFn = () => client.get<FundingApplicationSchemas.ConnectorPropertiesSchema>(fetchUrl, { params });

  return useSuspenseQuery({
    queryKey: [fetchUrl, postConnectPath],
    queryFn,
    select: ({ data }) => data,
    refetchOnMount: "always",
  });
};
